var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bg-gray-50 px-2 py-1 border border-gray-200 text-gray-500 rounded"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }